const operatorCloth = [

  {label: 'форма UTV', value: ''},
  {label: 'Классическая', value: ''},
  {label: 'Свободная', value: ''}

]

export default operatorCloth